angular.module("avant.customer_applications.directives").directive "popOver", ->
  scope:
    eventHandler: '&'
  retrict: 'A'
  priority: 1
  terminal: true
  link: (scope, element, attr) ->
    element.bind 'click', ($event) ->
      if attr.toggle == 'popover'
        $event.preventDefault()
      else
        scope.$eval(attr.ngClick)
      return
    element.popover
      trigger: 'hover'
    return


